/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, ModalGeneric, Loader } from 'ypf-pas-general-ui-components';

import useToast from '../../../../../hooks/useToast';
import LoaderContext from '../../../../../context/LoaderProvider';
import {
  proveedorNotificador,
  proveedorAdministrador
} from '../../../../../security/constantsRols';
import { checkRol } from '../../../../../security';
import ProviderContainer from '../../../container/ProviderContainer/ProviderContainer';
import ProvidersTable from '../../../../../components/ProvidersTable/ProvidersTable';
import ConfirmAssignModal from '../../../../../components/AssignProviderModals/ConfirmAssignModal';
import ErrorAssignModal from '../../../../../components/AssignProviderModals/ErrorAssignModal';
import { getRequestTo } from '../../../../../services/serviceRequest';
import {
  postProviders,
  putAssignationProvider
} from '../../../../../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import './SolicitatedTab.scss';
import { DetailRequest, DetailRequestDefaultProp } from '../../../../../utils/globalPropTypes';
import DuplicatedRequestModal from '../../../../../components/DuplicatedRequestModal/DuplicatedRequestModal';

const SolicitatedTab = ({
  details,
  setActiveTab,
  hasPermissionToAddProvider,
  setIsPendingAuthorization
}) => {
  const history = useHistory();
  const { setNewToast } = useToast();
  const { id } = useParams();
  const { setLoader } = useContext(LoaderContext);

  const [providers, setProviders] = useState([]);
  const [duplicatedData, setDuplicatedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(null);
  const [providerData, setProviderData] = useState(null);
  const [newProviderData, setNewProviderData] = useState(null);
  const [errorEnum, setErrorEnum] = useState(null);
  const [showModalProviders, setShowModalProviders] = useState(false);
  const [showModalAssign, setShowModalAssign] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [loaderProviders, setLoaderProviders] = useState(false);

  useEffect(() => {
    setIsPendingAuthorization(false);
    setActiveTab('solicitado');
  }, []);

  useEffect(() => {
    setIsDisabledBtn(newProviderData?.some((provider) => provider?.notificate === null));
  }, [newProviderData]);

  const getDetailsSolicitateTo = async () => {
    setLoader(true);
    const detailsHeader = await getRequestTo(id);

    setProviders(detailsHeader);
    setLoader(false);
  };

  useEffect(() => {
    getDetailsSolicitateTo();

    return () => null;
  }, [id]);

  const assignProviderData = async () => {
    setLoaderProviders(true);
    try {
      const response = await putAssignationProvider(
        providerData.idSolicitudServicio,
        providerData.idProveedor,
        providerData.proveedor
      );

      if (!response.redireccionEnum) {
        setLoaderProviders(false);
        history.push('/');
        setNewToast({
          type: 'SUCCESS',
          message: `Se ha asignado la solicitud N° ${response.numeroSolicitud}`
        });
      } else {
        setLoaderProviders(false);
        setShowModalAssign(false);
        setErrorEnum(response?.redireccionEnum);
        setShowModalError(true);
      }
    } catch (error) {
      setLoaderProviders(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const postNewProviders = async () => {
    try {
      setLoaderProviders(true);
      const data = await postProviders(newProviderData, details.id);

      if (data) {
        setShowModalProviders(false);
        setNewToast({
          type: 'SUCCESS',
          message: data.mensaje
        });
        getDetailsSolicitateTo();
        setLoaderProviders(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoaderProviders(false);
    }

    return null;
  };

  return (
    <>
      {loaderProviders ? (
        <Loader show={loaderProviders} text="CARGANDO ..." />
      ) : (
        <>
          {/* TODO: Aqui se usa el endpoint de contratos vigentes solucion temporal, BE debe hacer si parte todavia */}
          <ModalGeneric
            backdrop="static"
            infoModal
            onHide={async () => setShowModalProviders(false)}
            primaryAction={() => {
              postNewProviders();
            }}
            primaryActionDisabled={isDisabledBtn}
            primaryActionLabel="Aceptar"
            secondaryAction={() => setShowModalProviders(false)}
            secondaryActionLabel="Salir"
            show={showModalProviders}
            size="xl"
            title="Agregar proveedor"
          >
            <ProviderContainer details={details} setNewProviderData={setNewProviderData} />
          </ModalGeneric>

          <ConfirmAssignModal
            assignProviderData={assignProviderData}
            numero={details?.numero}
            proveedor={providerData?.proveedor}
            setIsChecked={setIsChecked}
            setShowModalAssign={setShowModalAssign}
            showModalAssign={showModalAssign}
          />

          <ErrorAssignModal
            errorEnum={errorEnum}
            numero={details?.numero}
            proveedor={providerData?.proveedor}
            setActiveTab={setActiveTab}
            setIsChecked={setIsChecked}
            setProviderData={setProviderData}
            setShowModalError={setShowModalError}
            showModalError={showModalError}
          />

          {providers?.length > 0 && (
            <>
              <ProvidersTable
                calledFrom="assign"
                idRequest={id}
                idService={details?.servicio?.id}
                idsEventoPozo={details?.idsEventoPozo}
                isChecked={isChecked}
                providers={providers}
                setDuplicatedData={setDuplicatedData}
                setIsChecked={setIsChecked}
                setProviderData={setProviderData}
                setShowModal={setShowModal}
                setShowModalAssign={setShowModalAssign}
                tipoAsignacionEnum={details?.tipoAsignacion?.id}
                tipoUbicacion={details?.tipoUbicacion?.id}
                ubicacionStr={details?.ubicacionStr}
              />
              <DuplicatedRequestModal
                data={duplicatedData}
                handlePrimary={() => setShowModalAssign(true)}
                setShowModal={setShowModal}
                showModal={showModal}
              />
            </>
          )}
          {!(checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)) && (
            <div className="content-button-add">
              <Button
                disabled={!hasPermissionToAddProvider}
                label="Agregar Proveedor"
                onClick={() => setShowModalProviders(true)}
                type="button"
                variant="outline-primary"
                widthButton="164px"
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

SolicitatedTab.propTypes = {
  hasPermissionToAddProvider: PropTypes.bool,
  details: DetailRequest,
  setActiveTab: PropTypes.func,
  setIsPendingAuthorization: PropTypes.func
};

SolicitatedTab.defaultProps = {
  // TODO: preguntar si realmente deberia ir en false hasPermissionToAddProvider
  hasPermissionToAddProvider: false,
  details: DetailRequestDefaultProp,
  setActiveTab: () => {
    /* empty */
  },
  setIsPendingAuthorization: () => {}
};

export default SolicitatedTab;
